import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@/styles/overrides.scss";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        // myPrep brand palette
        primary: "#3D80E8",
        secondary: "#EBA614",
        accent: "#EBA614",
        anchor: "#3D80E8",
        pink: "#EB63EB",
        info: "#3D80E8",
        success: "#22A06B",
        error: "#E5484D",
        warning: "#EBA614",
      },
    },
  },
});
